import {Inertia} from '@inertiajs/inertia';
import {InertiaLink} from '@inertiajs/inertia-react';
import cx from 'classnames';
import React, {useState} from 'react';
import styled from 'styled-components';

import {H1} from '../../components/crousal/Headings';
import {Button, ButtonType, ButtonSize} from '../../components/crousal/Button';
import {TextInput} from '../../components/crousal/TextInput';
import {getParsedQueryString} from '../../components/utils/url';

const LoginBackgroundImage = styled.div`
 background: url('/images/unrankedsmurfs-login/mobile_loginbg.png');
 background-size: cover;

@media (min-width: 1024px) {
  background: url('/images/unrankedsmurfs-login/login_bg.png');
  background-size: cover;
  }
`;

interface IProps {
    errors: Record<'email' | 'password', string>;
    oldInput: Record<'email' | 'password', string>;
}

function performLogin(email: string, password: string, qs = '') {
    Inertia.post(`/login${qs}`, {email, password});
}

export function Login({errors, oldInput}: IProps) {
    const [email, setEmail] = useState(oldInput?.email ?? '');
    const [password, setPassword] = useState(oldInput?.password ?? '');

    const {next} = getParsedQueryString();
    const nextRedirectQS = next ? `?next=${next}` : '';

    function handleLogin() {
        performLogin(email, password, nextRedirectQS);
    }

    return (
        <LoginBackgroundImage className="h-screen">
            <div className="h-full flex relative">
                <div className={cx('w-full lg:w-3/5 bg-gray-100', 'pt-100 lg:pt-200')}>
                    <div className="w-4/5 md:w-1/2 xl:w-1/3 mx-auto mt-20">
                        <img src={"/images/unrankedsmurfs-login/login_shield.png"} alt={"shield image"}/>
                        <H1 className="text-smurfs-gold">Hello Again!</H1>

                        <TextInput
                            value={email}
                            onChange={setEmail}
                            onEnter={handleLogin}
                            placeholder={"Email"}
                            className="mt-6"
                            // Shows an error state in the input, but not the actual message.
                            // The message is shown for the second field.
                            error={errors.email ? '' : undefined}
                        />

                        <TextInput
                            type="password"
                            value={password}
                            onChange={setPassword}
                            onEnter={handleLogin}
                            placeholder={"Password"}
                            className="mt-4"
                            // There is no error state for the `password` field, so we show
                            // the one of the `email` one. This allows for both fields to look
                            // like they have an error, while only the `email` one really has.
                            error={errors.email}
                        />

                        <InertiaLink
                            href="/forgot-password"
                            className="block font-ubuntu mt-6 text-london-air-white"
                        >
                            I've forgotten my details.
                        </InertiaLink>

                        <InertiaLink
                            href={`/register${nextRedirectQS}`}
                            className="block font-ubuntu mt-4 w-full text-london-air-white"
                        >
                            Can’t Sign In? | Create Account
                        </InertiaLink>

                        <div className="flex mt-6 cursor-pointer text-md">
                            <Button type={ButtonType.DEFAULT} size={ButtonSize.DEFAULT} onClick={handleLogin}>
                                Login
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </LoginBackgroundImage>
    );
}
